/**
 * Which `dir` a piece of transcript text needs.
 *
 * Arabic flips the whole document (`I18nProvider` sets `dir="rtl"` on
 * `<html>`), and every element inherits it — including the ones printing
 * subtitle files. Bidi then reorders their content:
 *
 *   stored:    00:00:00,000 --> 00:00:03,250
 *              Hello and welcome to the speech to text service.
 *   on screen: 00:00:03,250 <-- 00:00:00,000
 *              .Hello and welcome to the speech to text service
 *
 * The downloaded bytes are fine — they come from `serializeCues()`, never
 * from the DOM — but this is the preview someone reads before downloading,
 * and in it the timings look wrong.
 *
 * A serialized subtitle document is left-to-right by construction: its
 * timecodes, arrows and `[Script Info]` headers are ASCII scaffolding
 * whatever language the speech is in. Prose is not — a plain-text transcript
 * or one cue's line should follow its own content, which is what `auto`
 * means and why it beats hardcoding `ltr`: the product transcribes Arabic
 * too, and that transcript belongs right-to-left.
 */
export function subtitleDocDir(format: string): 'ltr' | 'auto' {
  return format === 'text' ? 'auto' : 'ltr'
}

/** A single cue's text, or any other bare sentence of transcript: it is
 * whatever language was spoken, so let the browser read the first strong
 * character and decide. */
export const CUE_TEXT_DIR = 'auto'
